import { TextCustom } from 'components/Form/TextForm/styled';
import React from 'react';

const TextForm = ({ text }) => {
  return <TextCustom>{text}</TextCustom>;
};

export default TextForm;
